<!--Tarjeta que sale en la parte superior del dashboard del organizador (Se usa en el componenete analytic-list.vue)-->
<template>
    <v-card class="white--text analytic-card fill-height primary">
        <v-container class="fill-height">
            <v-row justify="center" align="center">
                <v-col cols="3" sm="4" md="3" class="py-0 py-lg-3 px-0">
                    <v-row justify="center">
                        <v-btn fab dark depressed class="primary lighten-2" :class="($vuetify.breakpoint.smAndDown)?'v-size--default':'v-size--large'">
                            <v-icon :style="getSize" color="white">
                                {{ icon }}
                            </v-icon>
                        </v-btn>
                    </v-row>
                </v-col>
                <v-col cols="9" sm="8" md="9" class="text-center text-md-left py-0 py-lg-3 px-1">
                    <h2 class="subtitle-1 font-weight-bold">
                        {{ title }}
                    </h2>
                    <h3 class="display-1 font-weight-bold" v-if="currency">${{ (Number(description)) | currency }}</h3>
                    <h3 class="display-1 font-weight-bold" v-else>{{ description }}</h3>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>
<script>
export default {
    props:{
        icon: { type:String, required:true },
        title: { type:String, required:true },
        description: { type:Number, required:true },
        currency: { type:Boolean, required:false },
    },
    computed:{
        getSize(){
            switch (this.$vuetify.breakpoint.name) {
                case 'xs': return 'font-size:1.8em'
                case 'sm': return 'font-size:1.8em'
                case 'md': return 'font-size:1.7em'
                case 'lg': return 'font-size:2em'
                case 'xl': return 'font-size:2.3em'
            }
        },
    }
}
</script>
<style scoped>
    .analytic-card{
        transition: 0.2s all ease-in-out;
    }
    .analytic-card:hover{
        transform: translateY(-10px)
    }
</style>